module.exports = __webpack_public_path__ + "img/email-verified.aef4dad8.png";